import React from "react";
import styled from 'styled-components'
// reactstrap components
import {
  Container,
  Row,
} from "reactstrap";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';
import container1 from 'assets/img/containers/container1.jpg'
import container2 from 'assets/img/containers/container2.jpg'
import container3 from 'assets/img/containers/container3.jpg'
import container4 from 'assets/img/containers/container4.jpg'
import container5 from 'assets/img/containers/container5.jpg'
import container6 from 'assets/img/containers/container6.jpg'
import container7 from 'assets/img/containers/container7.jpg'
import container8 from 'assets/img/containers/container8.jpg'
import container9 from 'assets/img/containers/container9.jpg'
import container10 from 'assets/img/containers/container10.jpg'
import container11 from 'assets/img/containers/container11.jpg'
import container12 from 'assets/img/containers/container12.jpg'
import container13 from 'assets/img/containers/container13.jpg'
import { useTranslation } from 'react-i18next'
const MainText = styled.h4`
`
const TitleText = styled.h3`
    text-align: center;
`
const BackImage = styled.img`
  height: 600px;
  width: 100%;
`
const StyledImage = styled.img`
width: 900px;
height: 100%;
`

function ProfilePage() {
    const { t } = useTranslation();
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
        <MainText>
            <TitleText><b>{t('Containers')}</b></TitleText>
            <div>
            <h4>
            {t('Container1')}
            <StyledImage src={container1} alt="container" />
            </h4>
            {t('Container1Text')}
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -33,3 м3
                </li>
                <li>
                {t('ContainerWeight')} -21 700 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container2')}
            </h4>
            {t('Container2Text')}
            <StyledImage src={container2} alt="container" />
            <ul>
                <li>
                    {t('ContainerLength')} -12,19 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -67,2 м3
                </li>
                <li>
                {t('ContainerWeight')} -26 580 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container3')}
            </h4>
            {t('Container3Text')}
            <StyledImage src={container3} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -12,19 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,90 м.
                </li>
                <li>
                {t('ContainerCapacity')} -76,0 м3
                </li>
                <li>
                {t('ContainerWeight')} -26 330 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container4Text')}
            </h4>
            {t('Container4Text')}
            <StyledImage src={container4} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -13,72 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,90 м.
                </li>
                <li>
                {t('ContainerCapacity')} -85.7 м3
                </li>
                <li>
                {t('ContainerWeight')} -28 300кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container5Text')}
            </h4>
            {t('Container5Text')}
            <StyledImage src={container5} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -32,0 м3
                </li>
                <li>
                {t('ContainerWeight')} -21 660 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container6')}
            </h4>
            {t('Container6Text')}
            <StyledImage src={container6} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -12,19 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,90 м.
                </li>
                <li>
                {t('ContainerCapacity')} -67,7 м3
                </li>
                <li>
                {t('ContainerWeight')} -26 000 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container7')}
            </h4>
            {t('Container7Text')}
            <StyledImage src={container7} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,90 м.
                </li>
                <li>
                {t('ContainerCapacity')} -33,2 м3
                </li>
                <li>
                {t('ContainerWeight')} -21 700 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container8')}
            </h4>
            {t('Container8Text')}
            <StyledImage src={container8} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,09 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,37 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -28,0 м3
                </li>
                <li>
                {t('ContainerWeight')} -23 950 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
            {t('Container9')}
            </h4>
            {t('Container9Text')}
            <StyledImage src={container9} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -12,19 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -66,0 м3
                </li>
                <li>
                {t('ContainerWeight')} -26 280 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
                {t('Container10')}
            </h4>
                {t('Container10Text')}
            <StyledImage src={container10} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,60 м.
                </li>
                <li>
                {t('ContainerCapacity')} -24,0 м3
                </li>
                <li>
                {t('ContainerWeight')} -21 000 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
                {t('Container11')}
            </h4>
                {t('Container11Text')}
            <StyledImage src={container11} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -27,9 м3
                </li>
                <li>
                {t('ContainerWeight')} -20 000 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
                {t('Container12')}
            </h4>
                {t('Container12Text')}
            <StyledImage src={container12} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -12,19 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -2,59 м.
                </li>
                <li>
                {t('ContainerCapacity')} -54,8 м3
                </li>
                <li>
                {t('ContainerWeight')} -39 470 кг.
                </li>
            </ul>
            </div>
            <hr />
            <div>
            <h4>
                {t('Container13')}
            </h4>
                {t('Container13')}
            <StyledImage src={container13} alt="container" />
            <ul>
                <li>
                {t('ContainerLength')} -6,06 м.
                </li>
                <li>
                {t('ContainerWidth')} -2,44 м.
                </li>
                <li>
                {t('ContainerHeight')} -1,29 м.
                </li>
                <li>
                {t('ContainerCapacity')} -14,36 м3
                </li>
                <li>
                {t('ContainerWeight')} -28 380 кг.
                </li>
            </ul>
            </div>
            <hr />
            <h4>
            {t('ContainerTypes')}
            </h4>
            {t('ContainerTypesText')}
            
        
        </MainText>
        <Row>
        
        </Row>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
